import {ReactElement} from "react";
import {EventBase} from "shared/core/Events/EventManager";

export class GroupOnCreateRow extends EventBase {
    ReturnType: ReactElement;

    constructor(public Render:()=>void) {
        super();
    }

    public static GetName() {
        return 'GroupOnCreateRow';
    }
}